import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_API_URL

export type NonRecommendedAssignmentReason = {
  code: number
  name: string
  requiresDetail: boolean
}

export const getActiveNonRecommendedAssignmentReasons = (): Promise<
  NonRecommendedAssignmentReason[]
> => {
  return axios
    .get(`${API_URL}/NonRecommendedAssignmentReason/active`)
    .then(
      (response: AxiosResponse<{data: NonRecommendedAssignmentReason[]}>) =>
        response.data.data ?? []
    )
}
